import { Injectable, inject } from '@angular/core'

import { Store } from '@ngrx/store'

import { Observable, of } from 'rxjs'

import { DocumentContextReference } from '../types/ai.types'

@Injectable({
  providedIn: 'root',
})
export class AiAnalystService {
  #store = inject(Store)

  generateFromDocument(documentContextReference: DocumentContextReference): Observable<any> {
    return of(documentContextReference)
  }
}
